import { Injectable, Signal, signal, WritableSignal } from '@angular/core'

enum NotificationType {
  Info = 'info',
  InfoOutline = 'info-outline',
  Confirm = 'confirm',
  Warning = 'warning',
  Error = 'error',
}

interface Notification {
  id: string
  title: string
  description: string
  type: NotificationType
  boldTitle?: boolean
}

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private readonly _notifications: WritableSignal<Map<string, Notification>> = signal(new Map())

  private static generateId(title: string, description: string): string {
    const bytes = new TextEncoder().encode(`${title}#${description}`)
    let id = ''
    for (const b of bytes) id += String.fromCharCode(b)
    return btoa(id)
  }

  private addNotification(notification: Notification) {
    this._notifications().set(notification.id, notification)
  }

  dismiss(id: string): void {
    this._notifications().delete(id)
  }

  get notifications(): Signal<Map<string, Notification>> {
    return this._notifications
  }

  confirm(title: string, description: string, boldTitle = true): void {
    this.addNotification({
      type: NotificationType.Confirm,
      id: NotificationService.generateId(title, description),
      title,
      description,
      boldTitle,
    })
  }

  error(title: string, description: string): void {
    this.addNotification({
      type: NotificationType.Error,
      id: NotificationService.generateId(title, description),
      title,
      description,
    })
  }

  missingDataError() {
    this.error(
      'Unvollständige Angaben',
      'Bitte geben Sie alle erforderlichen Informationen ein, um zum nächsten Schritt zu gelangen.'
    )
  }

  clear() {
    this._notifications().clear()
  }
}
